export default __webpack_public_path__ + "static/media/kamin-skorsten-default.8e9f8890.jpg";